<div class="tickets mb-4">
  <ul class="list-group">
    <li
      *ngFor="let ticket of getTicketTypeList(); let index = index"
      class="list-group-item bg-transparent py-2 px-0 border-bottom border-top-0 border-0 rounded-0"
    >
      <div
        class="event-ticket-type d-flex align-items-center gap-4 justify-content-between"
      >
        <div class="event-ticket-type ticket-type-information">
          <h2 class="h6 mb-1 fw-bold text-uppercase">{{ ticket.name }}</h2>
          <data class="amount d-block small" value="">{{
            !ticket.price && !ticket.min_donation_amount ? 'GRATIS' : (ticket.min_donation_amount ? 'Donación mínima: RD$' + (ticket.min_donation_amount | number) : 'RD$' + (ticket.price | number))
          }}</data>
        </div>

        <unavailable-button
          *ngIf="isUnavailable(ticket)"
          [soldOut]="isSoldOut(ticket)"
          [holdedOut]="isHoldedOut(ticket)"
          [product]="products[index]"
          (productEventEmitter)="onProductChangeEvent.emit($event)"
        ></unavailable-button>

        <selector-button
          [ticketType]="ticket"
          [product]="getProductByTicketTypeId(ticket.id)"
          [ticketTypeLefts]="ticketTypesLefts[ticket.id]"
          *ngIf="isSelector(ticket)"
          (productEventEmitter)="onProductChangeEvent.emit($event)"
        ></selector-button>

        <seat-picker-button
          [ticketType]="ticket"
          [eventMapImgSrc]="eventMapImgSrc"
          [product]="products[index]"
          (productEventEmitter)="onProductChangeEvent.emit($event)"
          (goToCheckout)="goToCheckout.emit()"
          *ngIf="isSeat(ticket)"
        ></seat-picker-button>
      </div>
    </li>

    <!-- 3D SEAT PICKER START -->
    <li
      class="list-group-item bg-transparent py-2 px-0 border-bottom border-top-0 border-0 rounded-0"
      *ngIf="ticketTypesWithBlockIds.length"
    >
      <div
        class="event-ticket-type d-flex align-items-center gap-4 justify-content-between"
      >
        <div class="event-ticket-type ticket-type-information">
          <h2 class="h6 mb-1 fw-bold text-uppercase">Grand Stand</h2>
        </div>


        <app-threed-seats-picker
        [ticketTypes]="ticketTypesWithBlockIds"
        (goToCheckout)="goToCheckout.emit()"
        (productEventEmitter)="onProductChangeEvent.emit($event)"
        ></app-threed-seats-picker>
      </div>
    </li>
    <!-- 3D SEAT PICKER END -->

    <!-- 2D SEAT PICKER START -->
    <li
      class="list-group-item bg-transparent py-2 px-0 border-top-0 border-0 rounded-0"
      *ngIf="event2dMapSrc && ticketTypesWithMapId.length"
    >
      <div
        class="event-ticket-type d-flex align-items-center gap-4 justify-content-between"
      >
        <div class="event-ticket-type ticket-type-information">
          <p class="h4 mb-1 fw-bold">MAPA 2D</p>
        </div>

        <unavailable-button
          *ngIf="isTwoMapSoldOut"
          [product]="products[0]"
          (productEventEmitter)="onProductChangeEvent.emit($event)"
          [soldOut]="true"
          [holdedOut]="false"
        ></unavailable-button>

          <app-2map-seats-picker
          *ngIf="!isTwoMapSoldOut"
          [ticketTypes]="ticketTypesWithMapId"
          [mapUrl]="event2dMapSrc"
          [event]="event!"
          (goToCheckout)="goToCheckout.emit()"
          (productEventEmitter)="onProductChangeEvent.emit($event)"
          ></app-2map-seats-picker>
      </div>
    </li>
    <!-- 2D SEAT PICKER END -->
  </ul>

  <div
    class="accordion accordion-flush"
    id="accordionFlushExample"
    *ngIf="isGroupedByDate()"
  >
    <div
      class="accordion-item bg-transparent"
      *ngFor="let day of days; let index = index"
    >
      <h3 class="accordion-header bg-transparent">
        <button
          class="accordion-button focus-ring focus-ring-dark text-dark px-0 bg-transparent text-uppercase fw-bold collapsed border-bottom border-dark"
          type="button"
          data-bs-toggle="collapse"
          [attr.data-bs-target]="'#' + day.split(' ')[0] + index"
          aria-expanded="false"
          [attr.aria-controls]="'#' + day.split(' ')[0] + index"
        >
          {{ day }}
        </button>
      </h3>
      <div
        [id]="day.split(' ')[0] + index"
        class="accordion-collapse collapse px-0"
      >
        <div class="accordion-body px-0">
          <ul class="list-group">
            <li
              *ngFor="let ticket of getGroupedByDayData(day); let index = index"
              class="list-group-item bg-transparent py-2 px-0 border-bottom border-top-0 border-0 rounded-0"
            >
              <div
                class="event-ticket-type d-flex align-items-center gap-4 justify-content-between"
              >
                <div class="event-ticket-type ticket-type-information">
                  <h2 class="h6 mb-1 fw-bold text-uppercase">
                    {{ ticket.name }}
                  </h2>
                  <data class="amount d-block small" value="">{{
                    !ticket.price ? 'GRATIS' : 'RD$' + (ticket.price | number)
                  }}</data>
                </div>

                <unavailable-button
                  *ngIf="isUnavailable(ticket)"
                  [soldOut]="isSoldOut(ticket)"
                  [holdedOut]="isHoldedOut(ticket)"
                  [product]="productsByDay[day][index]"
                  (productEventEmitter)="onProductChangeEvent.emit($event)"
                ></unavailable-button>

                <selector-button
                  [ticketType]="ticket"
                  [product]="productsByDay[day][index]"
                  [ticketTypeLefts]="ticketTypesLefts[ticket.id]"
                  *ngIf="isSelector(ticket)"
                  (productEventEmitter)="onProductChangeEvent.emit($event)"
                ></selector-button>

                <seat-picker-button
                  [ticketType]="ticket"
                  [eventMapImgSrc]="eventMapImgSrc"
                  [product]="productsByDay[day][index]"
                  (productEventEmitter)="onProductChangeEvent.emit($event)"
                  *ngIf="isSeat(ticket)"
                ></seat-picker-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
